/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */
import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types';
// import { useRecoilValue } from 'recoil';
import XLSX from "xlsx";
import Swal from 'sweetalert2'
import { authSign, requestBeacon } from '../service/role';
import { makeStyles, withStyles, useTheme } from '@material-ui/core/styles';

import iconexport from '../images/export.png'
import moment from 'moment'
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import SearchIcon from '@material-ui/icons/Search';


import InputGroup from 'react-bootstrap/InputGroup'
import { Col, Row, Container, Button } from 'react-bootstrap';
import { Navbar, Nav, Form } from 'react-bootstrap'
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableFooter from '@material-ui/core/TableFooter';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import IconButton from '@material-ui/core/IconButton';
import FirstPageIcon from '@material-ui/icons/FirstPage';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import LastPageIcon from '@material-ui/icons/LastPage';



import { Icon } from './Icon'
import CustomDateSelect from './CustomDateSelect'
// import Select from 'react-select';
// import { DateTime } from './share';

import { history } from '../router/route';
// import { personState } from "../store"
// import BeaconTable from './BeaconTable';

const useStyles2 = makeStyles({
    table: {
        minWidth: 500,
        marginTop: 30,
    },
});
const useStyles1 = makeStyles((theme) => ({
    root: {
        flexShrink: 0,
        marginLeft: theme.spacing(1.5),
    },
}));
const StyledTableCell = withStyles((theme) => ({
    head: {
        // backgroundColor: theme.palette.common.black,
        color: '#888888',
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);

function TablePaginationActions(props) {
    const classes = useStyles1();
    const theme = useTheme();
    const { count, page, rowsPerPage, onPageChange } = props;

    const handleFirstPageButtonClick = (event) => {
        onPageChange(event, 0);
    };

    const handleBackButtonClick = (event) => {
        onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
        onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = (event) => {
        onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
        <div className={classes.root}>
            <IconButton
                onClick={handleFirstPageButtonClick}
                disabled={page === 0}
                aria-label="first page"
            >
                {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
            </IconButton>
            <IconButton onClick={handleBackButtonClick} disabled={page === 0} aria-label="previous page">
                {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
            </IconButton>
            <IconButton
                onClick={handleNextButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="next page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
            </IconButton>
            <IconButton
                onClick={handleLastPageButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="last page"
            >
                {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
            </IconButton>
        </div>
    );
}

TablePaginationActions.propTypes = {
    count: PropTypes.number.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
};

const BeaconDetail = (props) => {
    const d = new Date();
    const startDate = new Date();
    const classes = useStyles2();
    const [beacons, setBeacons] = useState([])
    const [beaconsTemp, setBeaconsTemp] = useState([])
    const [searchTemp, setSearchTemp] = useState("")
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(50);

    const emptyRows = rowsPerPage - Math.min(rowsPerPage, beaconsTemp.length - page * rowsPerPage);
    // const [selectTemp, setSelectTemp] = useState({ value: null, label: 'All' })
    // const [beacon, setBeacon] = useState(null)
    const [dateRange, setDateRange] = useState([new Date(startDate.setDate(d.getDate() - 0)), d]);
    // const user = useRecoilValue(personState)

    // const [excel_data, setExcelData] = useState([])
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value));
        setPage(0);
    };

    // useEffect(() => {
    //   let isMounted = true; // note this mounted flag
    //   requestChartUsage();
    //   // convertData()
    //   return () => {
    //     isMounted = false;
    //   };

    // }, []);

    useEffect(() => {
        requestBeacons()
    }, [dateRange,searchTemp])

    async function requestBeacons() {
        const { zone_id, beacon_id } = props.location.state
        var finish = false
        var itemCount = 0
        var temp = []
        Swal.fire({
            html: 'กำลังโหลดข้อมูล <b></b>%',
            // timer: 2000,
            timerProgressBar: true,
            allowOutsideClick: false
        })
        Swal.isVisible()
        Swal.showLoading()
        do {
            const params = {
                "work": "BEACON.GET_DETAILS_BY_ID",
                "beacon_id": beacon_id,
                "zone_id": zone_id,
                "item_per_request": 100,
                "current_item_amount": itemCount,
                "search_value": searchTemp,
                "start": {
                    "date": parseInt(moment(dateRange[0]).format("DD")),
                    "month": parseInt(moment(dateRange[0]).format("MM")),
                    "year": parseInt(moment(dateRange[0]).format("YYYY")),
                    "hour": 0,
                    "minute": 0
                },
                "end": {
                    "date": parseInt((dateRange[1] !== null) ? moment(dateRange[1]).format("DD") : new Date().getDay()),
                    "month": parseInt((dateRange[1] !== null) ? moment(dateRange[1]).format("MM") : new Date().getMonth()),
                    "year": parseInt((dateRange[1] !== null) ? moment(dateRange[1]).format("YYYY") : new Date().getFullYear()),
                    "hour": 23,
                    "minute": 59
                }
            }
            // console.log(params)
            const res = await authSign()
            if (res.data.status === true) {
                const result = await requestBeacon('beacon', params)
                // console.log(params)
                if (result.data.status === true) {
                    if (result.data.result.list.length > 0) {
                        // setBeaconsTemp(result.data.result.list)
                        temp.push(...result.data.result.list)
                        setBeacons(result.data.result.beacon)
                        itemCount += result.data.result.list.length
                    } else {
                        finish = true
                    }
                    // console.log(itemCount)
                }
                else {
                    finish = true
                }
            }
        } while (!finish)
        setBeaconsTemp(temp)
        Swal.close()
    }
    // async function requestBeaconLogs(rxid) {
    //     // var beforeDate = moment().add(-1, 'M');
    //     var finish = false
    //     var itemCount = 0
    //     var temp = []
    //     Swal.fire({
    //         html: 'กำลังโหลดข้อมูล <b></b>%',
    //         // timer: 2000,
    //         timerProgressBar: true,
    //         allowOutsideClick: false
    //     })
    //     Swal.isVisible()
    //     Swal.showLoading()
    //     do {
    //         const params = {
    //             "work": "BEACON_LOG.GET_BY_RXID",
    //             "item_per_request": 50000,
    //             "current_item_amount": itemCount,
    //             "rxid": rxid,
    //             "start": {
    //                 "date": parseInt(moment(dateRange[0]).format("DD")),
    //                 "month": parseInt(moment(dateRange[0]).format("MM")),
    //                 "year": parseInt(moment(dateRange[0]).format("YYYY")),
    //                 "hour": 0,
    //                 "minute": 0
    //             },
    //             "end": {
    //                 "date": parseInt((dateRange[1] !== null) ? moment(dateRange[1]).format("DD") : new Date().getDay()),
    //                 "month": parseInt((dateRange[1] !== null) ? moment(dateRange[1]).format("MM") : new Date().getMonth()),
    //                 "year": parseInt((dateRange[1] !== null) ? moment(dateRange[1]).format("YYYY") : new Date().getFullYear()),
    //                 "hour": 23,
    //                 "minute": 59
    //             }
    //         }

    //         const res = await axios.post(`${process.env.REACT_APP_BEV_API}/v3/apis/beacon`, params, {
    //             auth: {
    //                 username: process.env.REACT_APP_USERNAME,
    //                 password: process.env.REACT_APP_PASSWORD
    //             }
    //         });
    //         if (res.data.status === true) {
    //             if (res.data.result.length > 0) {
    //                 temp.push(...res.data.result)
    //                 itemCount += res.data.result.length
    //             } else {
    //                 finish = true
    //             }
    //         } else {
    //             finish = true
    //         }
    //     } while (!finish)
    //     // setLogs(temp)
    //     // setTemps(temp)
    //     Swal.close()
    // }

    // async function requestLogs(value) {
    //     // var beforeDate = moment().add(-1, 'M');
    //     var finish = false
    //     var itemCount = 0
    //     var temp = []
    //     Swal.fire({
    //         html: 'กำลังโหลดข้อมูล <b></b>%',
    //         // timer: 2000,
    //         timerProgressBar: true,
    //         allowOutsideClick: false
    //     })
    //     Swal.isVisible()
    //     Swal.showLoading()
    //     do {
    //         const params = {
    //             "work": "BEACON_LOG.GET_BY_RXID",
    //             "item_per_request": 50000,
    //             "current_item_amount": itemCount,
    //             "rxid": selectTemp.value,
    //             "start": {
    //                 "date": parseInt(moment(value[0]).format("DD")),
    //                 "month": parseInt(moment(value[0]).format("MM")),
    //                 "year": parseInt(moment(value[0]).format("YYYY")),
    //                 "hour": 0,
    //                 "minute": 0
    //             },
    //             "end": {
    //                 "date": parseInt((value[1] !== null) ? moment(value[1]).format("DD") : new Date().getDay()),
    //                 "month": parseInt((value[1] !== null) ? moment(value[1]).format("MM") : new Date().getMonth()),
    //                 "year": parseInt((value[1] !== null) ? moment(value[1]).format("YYYY") : new Date().getFullYear()),
    //                 "hour": 23,
    //                 "minute": 59
    //             }
    //         }

    //         const res = await axios.post(`${process.env.REACT_APP_BEV_API}/v3/apis/beacon`, params, {
    //             auth: {
    //                 username: process.env.REACT_APP_USERNAME,
    //                 password: process.env.REACT_APP_PASSWORD
    //             }
    //         });
    //         if (res.data.status === true) {
    //             if (res.data.result.length > 0) {
    //                 temp.push(...res.data.result)
    //                 itemCount += res.data.result.length
    //             } else {
    //                 finish = true
    //             }
    //         } else {
    //             finish = true
    //         }
    //     } while (!finish)
    //     setLogs(temp)
    //     setTemps(temp)
    //     Swal.close()
    // }


    // const time = (t)=>{
    //   if (t>60){
    //     return `${Math.floor(Math.floor(t)/60)} นาที ${Math.floor(t)%60} วินาที`
    //   }else{
    //     return `${Math.floor(t)} วินาที`
    //   }

    // }

    const loadData = () => {
        let tempex = []
        beaconsTemp.map((row, i) => {
            // if(i===0){
            //   tempex.push(["คลาสหน้าจอ","จำนวนครั้ง","จำนวนคน","เวลาเฉลี่ย"]);
            // }
            var obj = {
                "วัน": `${moment(row._cd).utc().format('DD/MM/YYYY')}`,
                "เวลา": `${moment(row._cd).utc().format('HH:mm:ss')}`,
                "รหัสพนักงาน": `${row.person.employee_id}`,
                "ชื่อ": `${row.person.first_name}`,
                "นามสกุล": `${row.person.last_name}`,
                "ละติจูด": `${row.location.latitude}`,
                "ลองติจูด": `${row.location.longitude}`,
            }
            tempex.push(obj);
        })

        const ws = XLSX.utils.json_to_sheet(tempex);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, searchTemp);
        /* generate XLSX file and send to client */
        XLSX.writeFile(wb, `Beacon Log_${moment().format("DDMMYYYY-HH:mm:ss")}.xlsx`);
    }

    // const searchEmp = (emp) => {
    //     var result = temps.filter(function (el) {
    //         return el.emp_id.indexOf(emp) !== -1
    //     });
    //     setTemps(result)
    // }

    const onSearchChange = value => {
        console.log(value)

        // this.toggleOpen();
        setSearchTemp(value.target.value)
        if(value.target.value.length>3){
            setSearchTemp(value.target.value)
        }
        if(value.target.value.length===0){
            setSearchTemp(value.target.value) 
        }
    }

    const onSelectDate = value => {
        setDateRange(value)
        // console.log(value)
        // if (value[1] !== null) {
        //     requestLogs(value)
        // }
        // requestBeacons()

    }
    // beacons-location-detail/621d7e58e784567bdab7cc92
    function onClickBack() {
        const { location_id } = props.location.state
        const location = {
            pathname: '/beacons-location-detail/' + location_id,
        }
        history.push(location)
    }
    return (
        <>
            <Navbar bg="white" variant="white" className='border'>
                <Container>
                    <Nav.Link onClick={onClickBack} className="text-dark align-self-center">
                        <ChevronLeftIcon></ChevronLeftIcon> Back
                    </Nav.Link>
                    <Nav className="mr-auto" />
                    <Navbar.Text className="text-dark mx-1 clearfix">
                        <CustomDateSelect onChange={onSelectDate} dateRange={dateRange} />
                    </Navbar.Text>
                    <Button variant="outline-light" className="border text-dark" onClick={loadData}>
                        <img src={iconexport} width="24" alt={'iconexport'} className="align-self-center mr-1" />
                        Export to excel
                    </Button>
                    {/* <div className="media px-2">
                        <img src={iconavatar} alt={user ? user.profile ? user.profile.sub : '' : ''} className="align-self-center" />
                        <div className="media-body">
                            <p className="mb-0">{user ? user.profile ? user.profile.sub : '' : ''}</p>
                        </div>
                    </div> */}
                </Container>
            </Navbar>
            <Container>
                <Row>
                    <Col xs="3" md={4} sm={3} lg="5">
                        <div className="d-flex align-items-center py-2 text-green">
                            <Icon
                                className="mr-2 align-self-center"
                                width={32}
                                height={32}
                                aria-hidden="true"
                                icon='BeaconIcon'
                            />
                            <div className="d-flex flex-column">
                                <h6 className='mb-0'>{beacons ? beacons.name : ''}</h6>
                                <p className='mb-0'>พบข้อมูล {beacons ? beacons.record ? beacons.record.amount : '' : ''} รายการ</p>
                            </div>
                        </div>
                    </Col>
                    <Col xs="3" md={2} lg="2">
                        <div className="d-flex flex-column py-2">
                            <label className='mb-0 text-muted text-bolder'>ละติจูด</label>
                            <h6 className='mb-0 font-weight-light'>{beacons ? beacons.latitude : ''}</h6>
                        </div>
                    </Col>
                    <Col xs="3" md={2} lg="2">
                        <div className="d-flex flex-column py-2">
                            <label className='mb-0 text-muted text-bolder'>ลองติจูด</label>
                            <h6 className='mb-0 font-weight-light'>{beacons ? beacons.longitude : ''}</h6>
                        </div>
                    </Col>
                    <Col xs="6" md={4} lg="3">
                        <Form.Group className='mb-0 py-2'>
                            <InputGroup.Prepend className='position-absolute'>
                                <InputGroup.Text id="basic-addon1" className="bg-white border-0 bg-transparent mt-1">
                                    <SearchIcon></SearchIcon>
                                </InputGroup.Text>
                            </InputGroup.Prepend>
                            <Form.Control type="text" placeholder="ค้นหา" style={{ paddingLeft: '2.5rem' }} onChange={onSearchChange} />
                        </Form.Group>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <TableContainer>
                            <Table className={classes.table} size="small" aria-label="custom pagination table">
                                <TableHead>
                                    <TableRow>
                                        <StyledTableCell>วัน</StyledTableCell>
                                        <StyledTableCell align="right">เวลา</StyledTableCell>
                                        <StyledTableCell align="right">รหัสพนักงาน</StyledTableCell>
                                        {/* <StyledTableCell align="right">Beacon ID</StyledTableCell> */}
                                        {/* <StyledTableCell align="right">ชื่อสถานที่</StyledTableCell> */}
                                        <StyledTableCell align="right">ชื่อ</StyledTableCell>
                                        <StyledTableCell align="right">นามสกุล</StyledTableCell>
                                        <StyledTableCell align="right">ละติจูด</StyledTableCell>
                                        <StyledTableCell align="right">ลองติจูด</StyledTableCell>
                                        {/* <StyledTableCell align="right">ระยะ</StyledTableCell> */}
                                        {/* <StyledTableCell align="right">รุ่นโทรศัพท์</StyledTableCell> */}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    
                                    {(rowsPerPage > 0
                                        ? beaconsTemp.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                        : beaconsTemp
                                    ).map((row, key) => (
                                        <TableRow key={key}>
                                            <TableCell component="th" scope="row">
                                                {/* <Link style={{color:"#027840","cursor": "pointer"}} onClick={(event) => handleClick(event, row._id)}> */}
                                                {moment(row.created_date).utc().format('DD/MM/YYYY')}
                                                {/* </Link> */}
                                                {/* <Link to={ '/'+row.screen.id}>{row.screen.name}</Link> */}

                                            </TableCell>
                                            <TableCell style={{ width: 120 }} align="right">
                                                {moment(row.created_date).utc().format('HH:mm:ss')}
                                            </TableCell>
                                            <TableCell style={{ width: 130 }} align="right">
                                                {row.person.employee_id}
                                            </TableCell>
                                            {/* <TableCell style={{ width: 160 }} align="right">
                                {row.beacon.minor_id}
                            </TableCell> */}
                                            {/* <TableCell style={{ width: 160 }} align="right">
                                {row.beacon.code_name}
                            </TableCell> */}
                                            <TableCell style={{ width: 160 }} align="right">
                                                {row.person.first_name}
                                            </TableCell>
                                            <TableCell style={{ width: 160 }} align="right">
                                                {row.person.last_name}
                                            </TableCell>
                                            <TableCell style={{ width: 130 }} align="right">
                                                {row.location.latitude}
                                            </TableCell>
                                            <TableCell style={{ width: 130 }} align="right">
                                                {row.location.longitude}
                                            </TableCell>
                                            {/* <TableCell style={{ width: 100 }} align="right">
                                {row.meter.toFixed(3)}
                            </TableCell>
                            <TableCell style={{ width: 140 }} align="right">
                                {row.device ? `${row.device ? row.device.brand : ''}, ${row.device ? row.device.model : ''}` : '-'}
                            </TableCell> */}
                                        </TableRow>
                                    ))}

                                    {emptyRows > 0 && (
                                        <TableRow style={{ height: 53 * emptyRows }}>
                                            <TableCell colSpan={6} />
                                        </TableRow>
                                    )}
                                </TableBody>
                                <TableFooter>
                                    <TableRow>
                                        <TablePagination
                                            // rowsPerPageOptions={[rowsPerPage, 25, { label: 'All', value: -1 }]}
                                            colSpan={8}
                                            count={beaconsTemp.length}
                                            rowsPerPage={rowsPerPage}
                                            page={page}
                                            // SelectProps={{
                                            //     inputProps: { 'aria-label': 'rows per page' },
                                            //     native: true,
                                            // }}
                                            onPageChange={handleChangePage}
                                            onRowsPerPageChange={handleChangeRowsPerPage}
                                            ActionsComponent={TablePaginationActions}
                                        />
                                    </TableRow>
                                </TableFooter>
                            </Table>
                        </TableContainer>
                    </Col>
                </Row>
            </Container>
        </>
    )

}

export default BeaconDetail